module.exports = __webpack_public_path__ + "img/SocialMedia.d8969bfb.png";